import { useQuery } from 'react-query';

import { getScheduleQualityScore as queryFn } from 'api/endPoints/getScheduleQualityScore';
import { QueryResponse } from 'api/endPoints/getScheduleQualityScore/types';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetScheduleQualityScore = (params) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getScheduleQualityScore', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId) && Boolean(params.contractId),
    });
};
